
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class SummaryCard extends Vue {
	@Prop({ required: true }) readonly icon!: string;
	@Prop({ required: true }) readonly color!: string;
	@Prop({ required: true }) readonly description!: string;
	@Prop({ required: true }) readonly amount!: string;

	get defaultInitialsClasses(): string {
		return `${this.color} icon-container flex items-center justify-center p-2 shadow-sm w-14 h-14 rounded-md mr-3.5`;
	}
}
